import Axios from 'axios'
import api from '@/services/api'
export default {
    namespaced: true,
    state: {
        series: [],
        seriercom: []
    },
    getters: {
        series: (state) =>{
            for(var i=0; i< state.series.length; i++)
            {
                let compose = state.series[i]
                compose=  { "txt": compose.series + compose.current_value }
                //console.log(compose)
                state.series[i] = Object.assign(state.series[i] ,compose)
            }
            state.series.push({})
            state.series.splice(-1,1)
            return state.series
        }
  
    },
    mutations: {
      setSeries(state, series) {
          state.series = series
      }
    },
    actions: {
        fetchSeries: async( { commit }) => {
          const series = (await Axios.get(api.baseUrl + 'bookseries')).data
          await commit('setSeries', series) 
      }
    }
  }